import BN from "bn.js";
import moment from "moment";
import * as React from "react";
import { Option } from "space-monad";
import styled from "styled-components";
import { Icon } from "../../../../../components/icons";
import {
  CenteredFlex,
  columnFlex,
  Flex,
  Grid,
} from "../../../../../components/layout";
import { colours } from "../../../../../styles/colours";
import { device, size } from "../../../../../styles/media";
import { formatEther } from "../../../../../utils/utils";

const MainIcon = styled(Icon)`
  height: 8em;
  width: 8em;
  margin: 2em 0;
`;

interface IResultPageProps {
  error: Option<Error>;
  amount: Option<BN>;
}

const Wrapper = styled(Flex)`
  ${columnFlex};
  ${CenteredFlex};
  max-width: 100%;

  @media ${device.tablet} {
    width: 30em;
    height: 20em;
  }
`;

const Title = styled.h1`
  @media (max-width: ${size.tablet - 1}px) {
    margin-top: 0;
  }
`;

const ItemLabel = styled.div`
  text-align: right;
  font-weight: 700;
`;

const ResultPage: React.FunctionComponent<IResultPageProps> = ({
  error,
  amount,
}) => {
  return (
    <Wrapper>
      {error.fold(
        () => (
          <>
            <Title>Success!</Title>
            <MainIcon type="veryGoodCheck" />
            {amount.fold(
              () => (
                <p>You have successfully locked your $SKRT</p>
              ),
              (am) => (
                <Grid col-xs={2}>
                  <ItemLabel>Staked:</ItemLabel>
                  <div>$SKRT {formatEther(am)}</div>
                  <ItemLabel>Maturity Date:</ItemLabel>
                  <div>{moment().add(1, "year").format("DD-MM-yyyy")}</div>
                </Grid>
              )
            )}
          </>
        ),
        (err) => (
          <>
            <Title>Error</Title>
            <MainIcon type="close" colour1={colours.redFailed} />
            <p>{err.message}</p>
          </>
        )
      )}
    </Wrapper>
  );
};

export default ResultPage;
